import { createRouter, createWebHistory } from "vue-router";
import DashboardLayout from "@/layout/DashboardLayout"
import Guard from '../services/middleware';
/*
// site
import Home from "../views/Site/Home.vue";
import NoticiaSite from "../views/Site/Noticia.vue";
import Eventos from "../views/Site/Eventos.vue";
import Turismo from "../views/Site/Turismo.vue";
import Agronegocio from "../views/Site/Agronegocio.vue";
import Busca from "../views/Site/Busca.vue";
import Parceiro from "../views/Site/Parceiro.vue";
import ColunistaNome from "../views/Site/ColunistaNome.vue";
import TodosColunistas from "../views/Site/TodosColunistas.vue";
import ColunaSite from "../views/Site/ColunaSite.vue";
import PoliticaDePrivacidade from "../views/Site/PoliticaDePrivacidade.vue";
import EventoSite from "../views/Site/EventoSite.vue";
import Videos from "../views/Site/Videos.vue";
import VideoSite from "../views/Site/VideoSite.vue";
import Negocios from "../views/Site/Negocios.vue";
import PublicarAnuncio from "../views/Site/PublicarAnuncio.vue";
import Avaliando from "../views/Site/Avaliando.vue";
import AnuncioSite from "../views/Site/AnuncioSite.vue";
import NegocioCategoria from "../views/Site/NegocioCategoria.vue";
import SobreNos from "../views/Site/SobreNos.vue";
import Contos from "../views/Site/Contos.vue"
import ContosNome from "../views/Site/ContosNome.vue"
import PagAnuncio from "../views/Site/PagAnuncio.vue"
*/
// sistema
import Inicio from "../views/Sistema/Inicio.vue";
import LoginAdm from "../views/Sistema/LoginAdm.vue";
import Categoria from "../views/Sistema/Categoria.vue";
import CadastrarCategoria from "../views/Sistema/CadastrarCategoria.vue";
import Noticia from "../views/Sistema/Noticia.vue";
import CadastrarNoticia from "../views/Sistema/CadastrarNoticia.vue";
import Usuario from "../views/Sistema/Usuario.vue";
import Usuarios from "../views/Sistema/Usuarios.vue";
import CadastrarUsuario from "../views/Sistema/CadastrarUsuario.vue";
import Colunista from "../views/Sistema/Colunista.vue";
import Coluna from "../views/Sistema/Coluna.vue";
import CadastrarColunista from "../views/Sistema/CadastrarColunista.vue";
import CadastrarColuna from "../views/Sistema/CadastrarColuna.vue";
import Evento from "../views/Sistema/Evento.vue";
import CadastrarEvento from "../views/Sistema/CadastrarEvento.vue";
import Parceiros from "../views/Sistema/Parceiros.vue";
import CadastrarParceiro from "../views/Sistema/CadastrarParceiro.vue";
import Propagandas from "../views/Sistema/Propagandas.vue";
import CategoriaProganda from "../views/Sistema/CategoriaProganda.vue";
import CadastrarCategoriaPropaganda from "../views/Sistema/CadastrarCategoriaPropaganda.vue";
import CadastrarPropaganda from "../views/Sistema/CadastrarPropaganda.vue";
import CategoriaNegocio from "../views/Sistema/CategoriaNegocio.vue";
import CadastrarCategoriaNegocio from "../views/Sistema/CadastrarCategoriaNegocio.vue";
import GrupoNegocio from "../views/Sistema/GrupoNegocio.vue";
import CadastrarGrupoNegocio from "../views/Sistema/CadastrarGrupoNegocio.vue";
import Negocio from "../views/Sistema/Negocio.vue";
import CadastrarNegocio from "../views/Sistema/CadastrarNegocio.vue";
import ContosConta from "../views/Sistema/ContosConta.vue";
import CadastrarConto from "../views/Sistema/CadastrarConto.vue";

const routes = [
  /*
  {
    path: "/",
    name: "home",
    components: { default: Home },
  },
  {
    path: "/noticia/:titulo_url",
    name: "noticia",
    components: { default: NoticiaSite },
  },

  {
    path: "/colunista/:nome_url",
    name: "colunistaNome",
    components: { default: ColunistaNome },
  },
  {
    path: "/ver-todos-colunistas",
    name: "todosColunistas",
    components: { default: TodosColunistas },
  },
  {
    path: "/coluna/:titulo_url",
    name: "colunaSite",
    components: { default: ColunaSite },
  },
  {
    path: "/turismo",
    name: "turismo",
    components: { default: Turismo },
  },
  {
    path: "/negocios",
    name: "Negocios",
    components: { default: Negocios },
  },
  {
    path: "/eventos",
    name: "eventos",
    components: { default: Eventos },
  },
  {
    path: "/eventos/:titulo_url",
    name: "eventoSite",
    components: { default: EventoSite },
  },
  {
    path: "/agronegocio",
    name: "agronegocio",
    components: { default: Agronegocio },
  },
  {
    path: "/parceiros",
    name: "parceiro",
    components: { default: Parceiro },
  },
  {
    path: "/agronegocio",
    name: "agronegocio",
    components: { default: Agronegocio },
  },
  {
    path: "/videos",
    name: "videos",
    components: { default: Videos },
  },
  {
    path: "/video/:titulo_url",
    name: "videoSite",
    components: { default: VideoSite },
  },
  {
    path: "/politica-de-privacidade",
    name: "politicaDePrivacidade",
    components: { default: PoliticaDePrivacidade },
  },
  {
    path: "/publicar-anuncio",
    name: "publicarAnuncio",
    components: { default: PublicarAnuncio },
  },
  {
    path: "/anuncio/:id",
    name: "anuncioSite",
    components: { default: AnuncioSite },
  },
  {
    path: "/avaliacao-de-negocio",
    name: "avaliando",
    components: { default: Avaliando },
  },
  {
    path: "/negocios-por-categoria/:id",
    name: "negocioCategoria",
    components: { default: NegocioCategoria },
  },
  {
    path: "/sobre-nos",
    name: "SobreNos",
    components: { default: SobreNos },
  },
  {
    path: "/busca/:resultado_busca",
    name: "Busca",
    components: { default: Busca },
  },
  {
    path: "/contos-que-a-gente-conta/:num_pagina",
    name: "Contos",
    components: { default: Contos },
  },
  {
    path: "/contos-que-a-gente-conta",
    name: "ContosDois",
    components: { default: Contos },
  },
  {
    path: "/contos-que-a-gente-conta/conto/:titulo_url",
    name: "ContosNome",
    components: { default: ContosNome },
  },
  {
    path: "/pag-negocio",
    name: "PagAnuncio",
    components: { default: PagAnuncio },
  },*/
  {
    path: "/login",
    name: "loginAdm",
    components: { default: LoginAdm },
  },
  {
    path: "",
    redirect: "/inicio",
    component: DashboardLayout,
    children: [
      {
        path: '/inicio',
        name: "inicio",
        components: { default: Inicio },
        beforeEnter: Guard.auth

      },
      {
        path: '/categorias',
        name: 'categorias',
        components: { default: Categoria },
        beforeEnter: Guard.auth

      },
      {
        path: '/cadastrar-categoria',
        name: 'cadastrarCategoria',
        components: { default: CadastrarCategoria },
        beforeEnter: Guard.auth

      },
      {
        path: '/alterar-categoria/:id',
        name: 'alterarCategoria',
        components: { default: CadastrarCategoria },
        beforeEnter: Guard.auth

      },
      {
        path: '/noticias',
        name: 'noticias',
        components: { default: Noticia },
        beforeEnter: Guard.auth

      },
      {
        path: '/cadastrar-noticia',
        name: 'cadastrarNoticia',
        components: { default: CadastrarNoticia },
        beforeEnter: Guard.auth

      },
      {
        path: '/editar-noticia/:id',
        name: 'editarNoticia',
        components: { default: CadastrarNoticia },
        beforeEnter: Guard.auth

      },
      {
        path: '/usuarios',
        name: 'usuarios',
        components: { default: Usuario },
        beforeEnter: Guard.auth
      },
      {
        path: '/usuarios-teste',
        name: 'Usuarios',
        components: { default: Usuarios },
        beforeEnter: Guard.auth
      },
      {
        path: '/cadastrar-usuario',
        name: 'cadastrarUsuario',
        components: { default: CadastrarUsuario },
        beforeEnter: Guard.auth

      },
      {
        path: '/alterar-usuario/:id',
        name: 'alterarUsuario',
        components: { default: CadastrarUsuario },
        beforeEnter: Guard.auth

      },
      {
        path: '/colunistas',
        name: 'colunistas',
        components: { default: Colunista },
        beforeEnter: Guard.auth

      },
      {
        path: '/colunas',
        name: 'coluna',
        components: { default: Coluna },
        beforeEnter: Guard.auth

      },
      {
        path: '/cadastrar-colunista',
        name: 'cadastrarColunista',
        components: { default: CadastrarColunista },
        beforeEnter: Guard.auth

      },
      {
        path: '/cadastrar-coluna',
        name: 'cadastrarColuna',
        components: { default: CadastrarColuna },
        beforeEnter: Guard.auth

      },
      {
        path: '/editar-coluna/:id',
        name: 'editarColuna',
        components: { default: CadastrarColuna },
        beforeEnter: Guard.auth

      },
      {
        path: '/alterar-colunista/:id',
        name: 'alterarColunista',
        components: { default: CadastrarColunista },
        beforeEnter: Guard.auth

      },
      {
        path: '/evento',
        name: 'evento',
        components: { default: Evento },
        beforeEnter: Guard.auth

      },
      {
        path: '/cadastrar-evento',
        name: 'cadastrarEvento',
        components: { default: CadastrarEvento },
        beforeEnter: Guard.auth

      },
      {
        path: '/editar-evento/:id',
        name: 'editarEvento',
        components: { default: CadastrarEvento },
        beforeEnter: Guard.auth

      },
      {
        path: '/parceiros',
        name: 'parceiros',
        components: { default: Parceiros },
        beforeEnter: Guard.auth
      },
      {
        path: '/cadastrar-parceiro/',
        name: 'cadastrarParceiro',
        components: { default: CadastrarParceiro },
        beforeEnter: Guard.auth
      },
      {
        path: '/editar-parceiro/:id',
        name: 'editarParceiro',
        components: { default: CadastrarParceiro },
        beforeEnter: Guard.auth
      },
      {
        path: '/propagandas/',
        name: 'propagandas',
        components: { default: Propagandas },
        beforeEnter: Guard.auth
      },
      {
        path: '/cadastrar-propaganda',
        name: 'cadastrarPropaganda',
        components: { default: CadastrarPropaganda },
        beforeEnter: Guard.auth
      },
      {
        path: '/alterar-propaganda/:id',
        name: 'alterarPropaganda',
        components: { default: CadastrarPropaganda },
        beforeEnter: Guard.auth
      },
      {
        path: '/categoria-propaganda',
        name: 'categoriaProganda',
        components: { default: CategoriaProganda },
        beforeEnter: Guard.auth
      },
      {
        path: '/cadastrar-categoria-propaganda',
        name: 'cadastrarCategoriaPropaganda',
        components: { default: CadastrarCategoriaPropaganda },
        beforeEnter: Guard.auth
      },
      {
        path: '/categoria-negocio',
        name: 'CategoriaNegocio',
        components: { default: CategoriaNegocio },
        beforeEnter: Guard.auth
      },
      {
        path: '/cadastrar-categoria-negocio',
        name: 'CadastrarCategoriaNegocio',
        components: { default: CadastrarCategoriaNegocio },
        beforeEnter: Guard.auth
      },
      {
        path: '/alterar-categoria-negocio/:id',
        name: 'alterarCetegoriaNegocio',
        components: { default: CadastrarCategoriaNegocio },
        beforeEnter: Guard.auth
      },
      {
        path: '/grupo-negocio',
        name: 'GrupoNegocio',
        components: { default: GrupoNegocio },
        beforeEnter: Guard.auth
      },
      {
        path: '/cadastrar-grupo',
        name: 'CadastrarGrupoNegocio',
        components: { default: CadastrarGrupoNegocio },
        beforeEnter: Guard.auth
      },
      {
        path: '/negocio',
        name: 'Negocio',
        components: { default: Negocio },
        beforeEnter: Guard.auth
      },
      {
        path: '/cadastrar-negocio',
        name: 'CadastrarNegocio',
        components: { default: CadastrarNegocio },
        beforeEnter: Guard.auth
      },
      {
        path: '/confirmar-negocio/:id',
        name: 'confirmarNegocio',
        components: { default: CadastrarNegocio },
        beforeEnter: Guard.auth
      },
      {
        path: '/contos',
        name: 'ContosConta',
        components: { default: ContosConta },
        beforeEnter: Guard.auth
      },
      {
        path: '/cadastrar-conto',
        name: 'CadastrarConto',
        components: { default: CadastrarConto },
        beforeEnter: Guard.auth
      },
      {
        path: '/alterar-conto/:id',
        name: 'AlterarConto',
        components: { default: CadastrarConto },
        beforeEnter: Guard.auth
      },
    ]
  },

  // {
  //   path: "/admin",
  //   redirect: "/admin/categorias",
  //   component: DashboardLayout,
  //   children: [
  //     {
  //       path: '/admin/categorias',
  //       name: 'Categorias',
  //       components: { default:Categoria}
  //     },
  //     {
  //       path: '/admin/cadastrar-categoria',
  //       name: 'Cadastrar Categoria',
  //       components: { default:CadastrarCategoria}
  //     }
  //   ]
  // }

];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active",
});

export default router;